<div class="content-wrapper-inner">
  <div class="table-topbar mb-20">
    <div class="search-holder">
      <input placeholder="Search email" type="search" class="form-control table-search" [formControl]="searchControl" />
      <span class="icon-search"></span>
    </div>
    <div class="table-action-holder">
      <div class="create">
        <a (click)="invitesShow()" class="btn btn-primary d-flex py-10 px-15"><span class="fas fa-user-friends"></span>Invites</a>
      </div>
    </div>
  </div>
  <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
    <app-subaccounts-table (actions)="userAction($event)" (onSearch)="handleSearch($event)" (changeBatch)="selectedRows = $event"></app-subaccounts-table>

    <div class="table-action-info-bar" *ngIf="selectedRows.length">
      <div class="info-left">
        <div class="text-icon-holder" (click)="batchClear()">
          <span class="icon">
            <span class="selected icon-done"></span>
          </span>
          <span class="text">{{selectedRows.length}} Selected</span>
        </div>
      </div>
      <div class="info-right">
        <div class="text-icon-holder" (click)="batchEnabled()">
          <span class="icon">
            <span class="icon-positive"></span>
          </span>
          <span class="text">Enable</span>
        </div>
        <div class="text-icon-holder" (click)="batchDisabled()">
          <span class="icon">
            <span class="icon-negative"></span>
          </span>
          <span class="text">Disable</span>
        </div>
        <div class="text-icon-holder" (click)="batchDelete()">
          <span class="icon">
            <span class="far fa-trash-alt"></span>
          </span>
          <span class="text">Delete</span>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #invitesModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Invites overview</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body pos-relative">
    <app-invite-index></app-invite-index>
  </div>
</ng-template>
